export enum MainRoute {
  SignUp = 'SignUp',
  Login = 'Login',
  LoginCallback = 'LoginCallback',
  Logout = 'Logout',
  LoginFailure = 'LoginFailure',
  Home = 'Home',
  Inventory = 'Inventory',
  // Important that InventorySearch/InventorySearchV2 have same prefix as Inventory so it's included in the same menu item
  InventorySearch = 'InventorySearch',
  InventorySearchV2 = 'InventorySearchV2',
  Sales = 'Sales',
  // Important that SalesSearch/SalesSearchV2 have same prefix as Sales so it's included in the same menu item
  SalesSearch = 'SalesSearch',
  SalesSearchV2 = 'SalesSearchV2',
  Purchases = 'Purchases',
  // Important that PurchaseSearch/PurchaseSearchV2 have same prefix as Purchases so it's included in the same menu item
  PurchaseSearch = 'PurchasesSearch',
  PurchaseSearchV2 = 'PurchasesSearchV2',
  RedirectToUK = 'RedirectToUK',
  SellerAccountSetting = 'SellerAccountSetting',
  Activity = 'Activity',
  Notifications = 'Notifications',
  ReleaseNotes = 'ReleaseNotes',
  Reports = 'Reports',
  ReportsV2 = 'ReportsV2',
  SyncCenter = 'SyncCenter',
  EventDiscovery = 'EventDiscovery',
  Email = 'Email',
  ReachProSupport = 'ReachProSupport',
  Settings = 'Settings',
  SponsoredListings = 'SponsoredListings',
  Payments = 'Payments',
  Discovery = 'Discovery',
  DiscoveryEvent = 'DiscoveryEvent',
  HelpCenter = 'HelpCenter',
  InventoryEvent = 'InventoryEvent',
  PurchasesEvent = 'PurchasesEvent',
  SalesEvent = 'SalesEvent',
  TicketUtilsLanding = 'TicketUtilsLanding',
  Customers = 'Customers',
  Accounting = 'Accounting',
  BoostCredit = 'BoostCredit',
  Seasons = 'Seasons',
}
